import types from "./homeTypes";

const initialState = {
    drawChart1: {chart: '',aspects:'',data:{name:''}},
	drawChart2: {chart: '',aspects:'',data:{name:''}},
    birthChart1: {},
	birthChart2: {},
	chartToPrint: '',
	loading: false,
	loadingPrint: false
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = initialState, { type, payload }) => {
	switch (type) {
        case 'ERROR_DRAW_CHART':
			return {
				...state,
                loading: false
			}
        case types.CHART1_DRAWN:
			return {
				...state,
				drawChart1: payload.data.content || initialState.drawChart1,
                loading: false
			}
		case types.BIRTH_CHART1_DRAWN:
			return {
				...state,
				birthChart1: payload || initialState.birthChart1
			}
		case types.CHART2_DRAWN:
			return {
				...state,
				drawChart2: payload.data.content || initialState.drawChart2,
                loading: false
			}
		case types.BIRTH_CHART2_DRAWN:
			return {
				...state,
				birthChart2: payload || initialState.birthChart2
			}
		case types.BIRTH_CHART_DRAWN_BOTH:
			return {
				...state,
				birthChart1: payload || initialState.birthChart1,
				birthChart2: payload || initialState.birthChart2
			}
		case types.CHART_DRAWN_BOTH:
			return {
				...state,
				drawChart1: payload.data.content || initialState.drawChart1,
				drawChart2: payload.data.content || initialState.drawChart2,
                loading: false
			}
		case types.HOME_LOADING:
			return {
				...state,
				loading: payload || initialState.loading,
			}
		case types.HOME_PRINT_LOADING:
			return {
				...state,
				loadingPrint: payload || initialState.loadingPrint,
			}
		case types.CHART_TO_PRINT:
			return {
				...state,
				chartToPrint: payload || initialState.chartToPrint,
				loading: false
			}
		case "RESET_APPLICATION":
			return {
				...state,
				...initialState
			}
		default:
			return state;
	}
};